import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import withMatch from '@/hocs/withMatch';
import { colorPalette, textStyles, fonts } from '../styles/styleGuide';
import { connect } from 'react-redux';
import { getApiDataRequest, getResultData, performApiRequest, invalidateApiDataRequest } from '../redux/apiData';
import { openModal, clearModalState, updateModalOpenState } from '../redux/modal';
import ButtonSecondary from './shared/buttons/ButtonSecondary';
import formatPrice from '../services/formatPrice';
import Caret from './shared/icons/Caret';
import get from 'lodash.get';
import onNetworkStatusChange from '@/processes/onNetworkStatusChange';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  return {
    showLogin: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'showLogin', {}),
    resultWishList: getResultData(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    }),
    postWishListRequest: getApiDataRequest(state.apiData, 'postWishList', {
      projectSlug: String(projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    handleClick: function handleClick(endpoint) {
      dispatch(openModal(colorPalette.beige, endpoint));
    },
    createWishList: function createWishList(houseId) {
      dispatch(performApiRequest('postWishList', {
        projectSlug: String(projectSlug)
      }, {
        house: houseId
      }));
    },
    invalidateData: function invalidateData() {
      dispatch(invalidateApiDataRequest('getWishLists', {
        projectSlug: String(projectSlug)
      }));
      dispatch(invalidateApiDataRequest('postWishList', {
        projectSlug: String(projectSlug)
      }));
    },
    closeModal: function closeModal() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var Pricelist = /*#__PURE__*/function (_Component) {
  function Pricelist() {
    var _this;
    _classCallCheck(this, Pricelist);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Pricelist, [].concat(args));
    _defineProperty(_this, "refMap", {});
    _defineProperty(_this, "state", {
      openMobile: _this.props.open === 0 && _this.props.index === 0
    });
    _defineProperty(_this, "openMobile", function (id) {
      var subNavMaxHeight = _this.refMap[id].offsetHeight;
      _this.setState(function (prevState) {
        return _defineProperty({}, 'subNavMaxHeight_' + id, subNavMaxHeight);
      });
      _this.setState({
        openMobile: !_this.state.openMobile
      });
    });
    _defineProperty(_this, "getSubNavMaxHeight", function (state, id) {
      return state['subNavMaxHeight_' + id];
    });
    return _this;
  }
  _inherits(Pricelist, _Component);
  return _createClass(Pricelist, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        postWishListRequest = _this$props.postWishListRequest,
        resultWishList = _this$props.resultWishList,
        match = _this$props.match,
        router = _this$props.router,
        invalidateData = _this$props.invalidateData,
        closeModal = _this$props.closeModal;
      if (postWishListRequest && postWishListRequest.networkStatus === 'success') {
        closeModal();
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(resultWishList.id || ''));
      }
      onNetworkStatusChange({
        onSucces: invalidateData,
        always: closeModal
      }, prevProps.postWishListRequest, postWishListRequest);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        bnr = _this$props2.bnr,
        renderWidth = _this$props2.renderWidth,
        status = _this$props2.status,
        showLogin = _this$props2.showLogin,
        extraField = _this$props2.extraField,
        variantCode = _this$props2.variantCode,
        createWishList = _this$props2.createWishList,
        surface = _this$props2.surface,
        auction = _this$props2.auction,
        price = _this$props2.price,
        priceListTable = _this$props2.priceListTable,
        groundLease = _this$props2.groundLease,
        gardenLocation = _this$props2.gardenLocation,
        priceLivingReady = _this$props2.priceLivingReady,
        modal = _this$props2.modal,
        nearWater = _this$props2.nearWater,
        houseVariant = _this$props2.houseVariant,
        handleClick = _this$props2.handleClick,
        parkingSpots = _this$props2.parkingSpots,
        onBoarding = _this$props2.onBoarding;
      var priceLabel = (status === 'free' || status === 'option') && (price === 0 || !price) ? 'Nog onbekend' : status === 'free' || status === 'option' ? formatPrice(price, {
        showDecimal: true
      }) : '-';
      var statusMessage = status === 'free' ? 'Te koop' : status === 'option' ? 'Onder optie' : 'Verkocht';
      var showButton = status !== 'sold' && showLogin;
      return __jsx(Fragment, null, (extraField > 2 || renderWidth <= 1067) && __jsx(StackableContainer, {
        "data-id": "components_Pricelist_StackableContainer"
      }, __jsx(Label, {
        onClick: function onClick() {
          return _this2.openMobile(id);
        },
        "data-id": "components_Pricelist_Label"
      }, __jsx(Left, {
        "data-id": "components_Pricelist_Left"
      }, "Bouwnr. ", bnr, " ", variantCode ? "- ".concat(variantCode) : ''), __jsx(Right, {
        expanded: this.state.openMobile,
        "data-id": "components_Pricelist_Right"
      }, statusMessage, __jsx("div", {
        "data-id": "components_Pricelist_div"
      }, __jsx(Caret, {
        direction: "down",
        color: colorPalette.white,
        "data-id": "components_Pricelist_Caret"
      })))), __jsx(Foldable, {
        expanded: this.state.openMobile,
        maxHeight: this.getSubNavMaxHeight(this.state, id),
        "data-id": "components_Pricelist_Foldable"
      }, __jsx("div", {
        ref: function ref(input) {
          _this2.refMap[id] = input;
        },
        "data-id": "components_Pricelist_div"
      }, __jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Kavelopp."), __jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, surface ? "".concat(surface, " m\xB2") : '-')), __jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "v.o.n. prijs"), __jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, (auction && status === 'free' || auction && status === 'option') && 'Bieden vanaf ', priceLabel)), priceListTable.groundLease && __jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Erfpacht"), __jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, status === 'free' || status === 'option' ? groundLease : '-')), priceListTable.priceLivingReady && __jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Woonklaar v.a."), __jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, status === 'free' || status === 'option' ? formatPrice(priceLivingReady, {
        showDecimal: true
      }) : '-')), priceListTable.gardenLocation && __jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Tuinligging"), __jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, gardenLocation)), priceListTable.parkingSpots && __jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Parkeerplaats(en)"), __jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, parkingSpots)), priceListTable.nearWater && __jsx(PropertyFold, {
        "data-id": "components_Pricelist_PropertyFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Aan het water"), __jsx(ContentFold, {
        "data-id": "components_Pricelist_ContentFold"
      }, nearWater ? 'Ja' : 'Nee')), __jsx(StatusFold, {
        "data-id": "components_Pricelist_StatusFold"
      }, __jsx(TitleFold, {
        "data-id": "components_Pricelist_TitleFold"
      }, "Status"), __jsx(ContentFoldStatus, {
        status: status,
        "data-id": "components_Pricelist_ContentFoldStatus"
      }, statusMessage)), showButton && __jsx(ButtonWrapperFold, {
        "data-id": "components_Pricelist_ButtonWrapperFold"
      }, __jsx(ButtonSecondary, {
        id: 'pricelist-make-new-design-for-house' + id,
        label: "Maak een ontwerp",
        type: "button",
        clickHandler: modal ? function (evt) {
          return createWishList(id);
        } : function (evt) {
          return handleClick({
            type: 'handshake',
            componentProps: {
              pricelistId: id,
              houseVariant: houseVariant,
              onBoarding: onBoarding
            }
          });
        },
        "data-id": "components_Pricelist_ButtonSecondary"
      }))))), extraField < 3 && renderWidth > 1067 && __jsx(Pricetable, {
        modal: modal,
        "data-id": "components_Pricelist_Pricetable"
      }, __jsx(Table, {
        "data-id": "components_Pricelist_Table"
      }, __jsx(TableContainer, {
        showLogin: showLogin,
        "data-id": "components_Pricelist_TableContainer"
      }, __jsx(HouseProperty, {
        width: 75,
        "data-id": "components_Pricelist_HouseProperty"
      }, bnr, " ", variantCode ? "- ".concat(variantCode) : ''), __jsx(HouseProperty, {
        width: 85,
        "data-id": "components_Pricelist_HouseProperty_38"
      }, surface ? "".concat(surface, " m\xB2") : '-'), __jsx(PriceContainer, {
        "data-id": "components_Pricelist_PriceContainer"
      }, __jsx(Auction, {
        "data-id": "components_Pricelist_Auction"
      }, auction && status === 'free' || auction && status === 'option' ? 'Bieden vanaf' : ''), __jsx(Price, {
        "data-id": "components_Pricelist_Price"
      }, priceLabel, (status === 'free' || status === 'option') && (priceLabel !== 0 || priceLabel) ? ' v.o.n.' : '')), priceListTable.groundLease && __jsx(HouseProperty, {
        width: 90,
        "data-id": "components_Pricelist_HouseProperty"
      }, status === 'free' || status === 'option' ? groundLease : '-'), priceListTable.priceLivingReady && __jsx(HouseProperty, {
        width: 120,
        "data-id": "components_Pricelist_HouseProperty_43"
      }, status === 'free' || status === 'option' ? formatPrice(priceLivingReady, {
        showDecimal: true
      }) : '-'), priceListTable.gardenLocation && __jsx(HouseProperty, {
        width: 95,
        "data-id": "components_Pricelist_HouseProperty_44"
      }, gardenLocation), priceListTable.parkingSpots && __jsx(HouseProperty, {
        width: 132,
        "data-id": "components_Pricelist_HouseProperty_45"
      }, parkingSpots), priceListTable.nearWater && __jsx(HouseProperty, {
        width: 101,
        "data-id": "components_Pricelist_HouseProperty_46"
      }, nearWater ? 'Ja' : 'Nee'), __jsx(Status, {
        status: status,
        "data-id": "components_Pricelist_Status"
      }, statusMessage)), showButton && __jsx(ButtonWrap, {
        "data-id": "components_Pricelist_ButtonWrap"
      }, __jsx(ButtonSecondary, {
        label: "Maak een ontwerp",
        id: 'pricelist-make-new-design-for-house' + id,
        type: "button",
        clickHandler: modal ? function (evt) {
          return createWishList(id);
        } : function (evt) {
          return handleClick({
            type: 'handshake',
            componentProps: {
              pricelistId: id,
              houseVariant: houseVariant,
              onBoarding: onBoarding
            }
          });
        },
        "data-id": "components_Pricelist_ButtonSecondary"
      })))));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(Pricelist));
var ButtonWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  > button {\n    width: 180rem;\n    letter-spacing: 0;\n    align-self: auto;\n    margin-right: 12rem;\n    cursor: pointer;\n  }\n"])));
var ButtonWrapperFold = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  > button {\n    letter-spacing: 0;\n    align-self: auto;\n    cursor: pointer;\n  }\n  margin-bottom: 32rem;\n  margin-top: 18rem;\n"])));
var ContentFoldStatus = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16rem;\n  width: 45%;\n  color: ", ";\n"])), fonts.primary, function (props) {
  return props.status === 'free' ? colorPalette.green : props.status === 'option' ? colorPalette.orange : colorPalette.beige;
});
var ContentFold = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16rem;\n  color: ", ";\n  width: 45%;\n"])), fonts.primary, colorPalette.textGrey);
var PropertyFold = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16rem;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1rem solid rgba(188, 173, 159, 0.1);\n  height: 30rem;\n  align-items: center;\n  width: 100%;\n"])), fonts.primary);
var TitleFold = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16rem;\n  color: ", ";\n"])), fonts.primary, colorPalette.textGrey);
var StatusFold = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16rem;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1rem solid rgba(188, 173, 159, 0.1);\n  height: 30rem;\n  align-items: center;\n  width: 100%;\n  color: ", ";\n"])), fonts.primary, function (props) {
  return props.status === 'free' ? colorPalette.green : props.status === 'option' ? colorPalette.orange : colorPalette.beige;
});
var Foldable = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding-left: 12rem;\n  padding-right: 12rem;\n  background-color: #fff;\n  max-height: ", "rem;\n  transition: max-height 0.22s ease-in-out;\n  overflow: hidden;\n"])), function (props) {
  return props.expanded ? props.maxHeight : '0';
});
var Left = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-left: 10rem;\n"])));
var Right = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 120rem;\n  margin-right: 10rem;\n\n  > div {\n    transition: transform 0.2s ease-in-out;\n    transform: ", ";\n    transform-origin: center center;\n  }\n"])), function (props) {
  return props.expanded ? 'scaleY(-1)' : 'scaleY(1)';
});
var StackableContainer = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  width: 100%;\n  box-shadow: 0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n"])));
var Label = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 40rem;\n  display: flex;\n  background-color: ", ";\n  align-items: center;\n  font-family: ", ";\n  font-size: 16rem;\n  color: #fff;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  z-index: 1;\n  cursor: pointer;\n"])), colorPalette.lightBeige, fonts.primary);
var TableContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: ", "%;\n  display: flex;\n  justify-content: space-between;\n  margin-left: 10rem;\n"])), function (props) {
  return props.showLogin ? 78 : 100;
});
var Table = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: auto;\n  background-color: white;\n  border-bottom: 1rem solid rgba(188, 173, 159, 0.1);\n  border-left: 1rem solid rgba(188, 173, 159, 0.1);\n  border-right: 1rem solid rgba(188, 173, 159, 0.1);\n"])));
var HouseProperty = styled.p(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  width: ", "rem;\n  align-self: center;\n"])), textStyles.bodyText, colorPalette.textGrey, function (props) {
  return props.width;
});
var PriceContainer = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 134rem;\n"])));
var Auction = styled.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14rem;\n  color: ", ";\n  margin-top: 15rem;\n"])), fonts.primary, colorPalette.textGrey);
var Price = styled.p(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: -14rem;\n"])), textStyles.bodyText, colorPalette.textGrey);
var Status = styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  ", ";\n  width: 90rem;\n  color: ", ";\n  align-self: center;\n"])), textStyles.bodyText, function (props) {
  return props.status === 'free' ? colorPalette.green : props.status === 'option' ? colorPalette.orange : colorPalette.beige;
});
var Pricetable = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  height: auto;\n  position: relative;\n  margin-left: ", "rem;\n"])), function (props) {
  return props.modal ? 0 : 100;
});